export default __webpack_public_path__ + "static/media/pictogramDonations40.fca06baf.svg";